<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Bolt, Nut, Washer Material Type Required'"
                        [binding]="'boltNutWasherMaterialType'"
                        [width]="280"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'High Torque Required'"
                        [binding]="'highTorqueRequired'"
                        [width]="160"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Flange Type Required'"
                        [binding]="'flangeTypeRequired'"
                        [width]="160"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
